<div
  class="grade-level-container"
  [ngClass]="
    getIsHeaderStyle()
      ? 'grade-level-container__header'
      : 'grade-level-container__control'
  "
>
  <h2
    *ngIf="getIsHeaderStyle(); else controlStyle"
    class="heavy-header-text header-style"
  >
    Select a Grade
  </h2>
  <ng-template #controlStyle>
    <div class="control-style">
      <p class="control-style__paragraph">Please select a Grade Level</p>
    </div>
    <mat-divider [vertical]="true"></mat-divider>
  </ng-template>

  <div class="grade-level-link--list">
    <ng-container
      *ngFor="let gradeLevel of gradeLevelList; trackBy: 'id' | trackByKey"
    >
      <div
        [ngClass]="
          (hover(gradeLevel.id) ? 'grade-hover' : 'grade-undecorated') +
          ' ' +
          (isSelected(gradeLevel.id) ? 'grade-selected' : 'grade-undecorated')
        "
        (mouseenter)="mouseEnter(gradeLevel.id)"
        (mouseleave)="mouseLeave(gradeLevel.id)"
      >
        <button
          *ngIf="!routeOnClick"
          class="grade-level-link--item"
          (mousedown)="mouseDown(gradeLevel.id)"
        >
          <div>
            <img
              class="grade-level-link--img"
              [src]="gradeLevel.icon"
              [alt]="gradeLevel.label"
            />
          </div>

          <div class="grade-level-link--label header-text">
            {{ gradeLevel.label }}
          </div>
        </button>
        <button
          *ngIf="routeOnClick"
          class="grade-level-link--item"
          [routerLink]="gradeLevel.link"
        >
          <div>
            <img
              class="grade-level-link--img"
              [src]="gradeLevel.icon"
              [alt]="gradeLevel.label"
            />
          </div>

          <div class="grade-level-link--label header-text">
            {{ gradeLevel.label }}
          </div>
        </button>
      </div>
    </ng-container>
  </div>
</div>
